import { PartnerPaymentProvider } from 'src/interfaces/payment'
import { State } from '../reducers/types'

export const getPaymentProvider = (state: State): PartnerPaymentProvider | null =>
  state.payment.paymentProvider

export const getShowSandboxUsBankBanner = (state: State): boolean =>
  state.payment.showSandboxUsBankBanner
